import ajax from './ajax.js'
import pointer from './typeAheadPointer.js'
import pointerScroll from './pointerScroll.js'

export default { ajax, pointer, pointerScroll }
